import { useEffect } from 'react';

export const UseChatPlus = () => {
  useEffect(() => {
    var d=document;;
    var s="https://app.chatplus.jp/cp.js";
    d["__cp_d"]="https://app.chatplus.jp";
    d["__cp_c"]="86d1b8fa_1";
    var a=d.createElement("script"), m=d.getElementsByTagName("script")[0];
    a.async=true;
    a.src=s;
    if (m.parentNode) {
      m.parentNode.insertBefore(a,m);
    }

    return () => {
      const scriptTags = Array.from(d.querySelectorAll('script'));
      const scriptsToRemove = scriptTags.filter(
        (script) => s && script.src.includes(s)
      );
      scriptsToRemove.forEach((script) => script.remove());
    };
  }, []);
}

export default UseChatPlus;
